import React, { useState, useEffect } from "react";
import bootstrap from "bootstrap/dist/js/bootstrap";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { api } from "../../../utils/Api";
import { useParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import { omit } from "lodash";

const animatedComponents = makeAnimated();

let myModal = {};
const initial_value = {
  sp_id: "",
  from: "",
  quantity: "",
  amount: "",
  selected_task: {},
};

export default function ModalMonthlySalaryPayment(props: any) {
  const [close_data, SetCloseData] = useState({
    action: "close",
  });
  const [id_value, SerIdValue] = useState(useParams());
  const [save_data, SetSaveData] = useState({});
  const [salary_paid_data, SetSalaryPaidData] = useState([]);
  const [is_add, SetIsAdd] = useState(false);
  const [salary_date, SetSalaryDate] = useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1)
  );
  const [pay_int_data, SetPayInitData] = useState({});
  const [amount_value, SetAmountValue] = useState();

  useEffect(() => {
    console.log("ModelAddMonthlySalary On mount :", props);
    let myModal1 = document.getElementById("MonthlySalaryPaymentModal");
    myModal1.addEventListener("hidden.bs.modal", function (event) {
      SetSaveData({});
      props.close(close_data);
    });
  }, []);

  useEffect(() => {
    if (props.open) {
      console.log("ModelAddMonthlySalary On Open :", props);
      get_monthly_salary_details();
      myModal = new bootstrap.Modal(
        document.getElementById("MonthlySalaryPaymentModal"),
        {}
      );
      myModal.show();
    }
  }, [props.open]);

  async function get_monthly_salary_details() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        sp_id: props.data.id,
      },
    };
    console.log("pass_data :", pass_data);
    let response = await api("/outlet/sp_monthly_salary_details", pass_data);
    console.log("sp_monthly_salary_details response :", response);
    if (response.response.hasOwnProperty("data")) {
      if (response.response.data.hasOwnProperty("salary_paid_data")) {
        SetSalaryPaidData(response.response.data.salary_paid_data);
      }
    }
  }

  async function get_pay_int(date_value) {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        sp_id: props.data.id,
      },
      post: {
        salary_date: date_value,
      },
    };
    console.log("pass_data :", pass_data);
    let response = await api("/outlet/sp_monthly_salary_pay_init", pass_data);
    console.log("sp_monthly_salary_pay_init response :", response);
    if (response.response.hasOwnProperty("salary_amount")) {
      SetPayInitData(response.response);
      SetAmountValue(response.response.pending_salary_amount);
    }
  }

  async function pay_salary() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        sp_id: props.data.id,
      },
      post: {
        salary_date: moment(salary_date).format("DD-MM-yyyy"),
        amount: amount_value,
      },
    };
    console.log("pass_data :", pass_data);
    let response = await api("/outlet/sp_monthly_salary_pay", pass_data);
    console.log("sp_monthly_salary_pay response :", response);
    if (response.response.hasOwnProperty("status")) {
      if (response.response.status) {
        //   SetPayInitData(response.response);
        SetIsAdd(false);
        get_monthly_salary_details();
      }
    }
  }

  return (
    <div
      className="modal fade"
      id="MonthlySalaryPaymentModal"
      tabIndex={-1}
      aria-labelledby="ModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="  modal-title" id="ModalLabel">
              {is_add ? "Pay Monthly Salary" : "Monthly Salary Payment List"}
            </h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            ></button>
          </div>
          <div className="modal-body">
            {is_add ? (
              <div className="row">

                <div className="col-md-4 col-6">
                  <div className="card mb-2 p-3 border">
                    <h6 className="text-gray fs-6 aHeight">Salary Amount</h6>
                    <p className="text-dark mb-0 fs-6 fw-600">₹ {pay_int_data.salary_amount}</p>
                  </div>
                </div>

                <div className="col-md-4 col-6">
                  <div className="card mb-2 p-3 border">
                    <h6 className="text-gray fs-6 aHeight">Paid Salary Amount</h6>
                    <p className="text-dark mb-0 fs-6 fw-600">₹ {pay_int_data.paid_salary_amount}</p>
                  </div>
                </div>

                <div className="col-md-4 col-6">
                  <div className="card mb-2 p-3 border">
                    <h6 className="text-gray fs-6 aHeight">Pending Salary Amount</h6>
                    <p className="text-dark mb-0 fs-6 fw-600">₹ {pay_int_data.pending_salary_amount}</p>
                  </div>
                </div>

                <div className="col-md-6 mt-3">
                  <label className="form-label">Select Date</label>
                  <DatePicker
                    selected={salary_date}
                    onChange={(date) => {
                      console.log("date :", date);
                      let modified_date = moment(date).format("DD-MM-yyyy");
                      console.log("moment modified_date", modified_date);
                      SetSalaryDate(date);
                      get_pay_int(modified_date);
                    }}
                    dateFormat="dd-MM-yyyy"
                    className="form-control"
                    showMonthYearPicker
                    showFullMonthYearPicker
                    showFourColumnMonthYearPicker
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label className="form-label">Enter Amount</label>
                  <input
                    className="form-control"
                    type="number"
                    value={amount_value}
                    onChange={(e) => {
                      if (
                        parseInt(pay_int_data.pending_salary_amount) >=
                        e.target.value
                      ) {
                        SetAmountValue(e.target.value);
                      } else {
                        console.log("Amount is high");
                      }
                    }}
                  />
                </div>
              </div>
            ) : (
              <div>
                <div className="d-flex">
                  <h6 className="fs-6">Salary Paid Data</h6>
                  <button
                    className="ms-auto btn btn-light-outline btn-sm"
                    onClick={() => {
                      console.log("Add");
                      SetIsAdd(true);
                      SetSalaryDate(
                        new Date(
                          new Date().getFullYear(),
                          new Date().getMonth(),
                          1
                        )
                      );
                      let modified_date = moment(
                        new Date(
                          new Date().getFullYear(),
                          new Date().getMonth(),
                          1
                        )
                      ).format("DD-MM-yyyy");
                      get_pay_int(modified_date);
                    }}
                  >
                    Add
                  </button>
                </div>
                {salary_paid_data != [] ? (
                  salary_paid_data.map((s_data: any, s_index: any) => (
                    <div className="row py-3 border-bottom">
                      <div className="col-6">
                        <h6 className="fs-6">{s_data.salary_date}</h6>
                      </div>
                      <div className="col-6 text-end">
                        <small>{s_data.created_at}</small>
                      </div>
                      
                      <div className="col-8">
                        <p className="mb-1">{s_data.created_user}</p>
                        <small>@{s_data.created_username}
                        </small>
                      </div>
                      <div className="col-4 text-end">
                      <p className="text-dark fs-600 fw-600 mb-1">₹ {s_data.amount}</p>
                      </div>
                      

                    </div>
                  ))
                ) : (
                  <p>No data</p>
                )}
              </div>
            )}
          </div>
          <div className="modal-footer">
            {is_add ? (
              <>
                <button
                  type="button"
                  className="btn btn-light-outline"
                  onClick={() => {
                    SetIsAdd(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-light-outline"
                  onClick={() => {
                    console.log("pay_salary");
                    pay_salary();
                  }}
                >
                  Pay
                </button>
              </>
            ) : (
              <button
                type="button"
                className="btn btn-light-outline"
                onClick={() => {
                  let item = close_data;
                  item.action = "close";
                  SetCloseData(item);
                  myModal.hide();
                }}
              >
                Close
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
